// Payroll cost persistence (Stage 3 prerequisite) — GeneratePayroll.js
// previously wrote nothing to Firestore; it was a pure file-in/file-out bank
// transfer generator. This captures the total net pay disbursed each run as
// ALM's own permanent-staff payroll cost, which flows into Operating
// Expenses/Monthly P&L as "Permanent ALM Payroll". It does NOT change how
// bank files are generated — this is purely additive.
import { collection, doc, getDocs, query, runTransaction, serverTimestamp, where } from "firebase/firestore";
import { auth, db } from "../../firebase";
import { assertPeriodOpen } from "./periodLockService";

const RUNS = "payroll_runs";

export async function createPayrollRun({ accountingPeriod, fileName, employees }) {
  if (!accountingPeriod) throw new Error("Enter the accounting period (YYYY-MM) for this payroll run.");
  if (!Array.isArray(employees) || !employees.length) throw new Error("No employee rows found in the uploaded payroll file.");

  await assertPeriodOpen(accountingPeriod);
  const totalNetPay = Math.round(employees.reduce((sum, e) => sum + Number(e.netPay || 0), 0));
  const runRef = doc(collection(db, RUNS));

  await runTransaction(db, async (transaction) => {
    transaction.set(runRef, {
      accountingPeriod,
      fileName: fileName || null,
      employeeCount: employees.length,
      totalNetPay,
      employees: employees.map((e) => ({
        employeeId: e.employeeId || null,
        employeeName: e.employeeName || null,
        netPay: Math.round(Number(e.netPay || 0)),
        bank: e.bank || null
      })),
      uploadedBy: auth.currentUser?.uid || null,
      uploadedByEmail: auth.currentUser?.email || null,
      uploadedAt: serverTimestamp()
    });
  });

  return { id: runRef.id, accountingPeriod, totalNetPay, employeeCount: employees.length };
}

export async function listPayrollRuns(accountingPeriod) {
  const q = query(collection(db, RUNS), where("accountingPeriod", "==", accountingPeriod));
  const result = await getDocs(q);
  return result.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function sumPayrollForPeriod(accountingPeriod) {
  const runs = await listPayrollRuns(accountingPeriod);
  return Math.round(runs.reduce((sum, run) => sum + Number(run.totalNetPay || 0), 0));
}
